<template>
		<v-container>
	<v-row>
        <v-col class="col-sm-6" cols="12">
			<v-text-field dense label="Clã" v-model="dados.outros.claAtual" readonly outlined></v-text-field>
        </v-col>
		<v-col class="col-sm-6" cols="12">
			<v-text-field dense label="Grau" v-model="dados.outros.grauAtual" readonly outlined></v-text-field>
        </v-col>
        <v-col class="col-sm-4" cols="12">
			<v-text-field dense label="CPF" v-model="dados.outros.cpf" outlined></v-text-field>
        </v-col>
		<v-col class="col-sm-4" cols="12">
			<v-text-field dense label="RG" v-model="dados.outros.rg" outlined></v-text-field>
        </v-col>
        <v-col class="col-sm-4" cols="12">
			<v-text-field dense label="Profissão" v-model="dados.outros.profissao" outlined></v-text-field>
        </v-col>
        <v-col class="col-sm-4" cols="12">
			<v-text-field dense label="Grau de Instrução" v-model="dados.outros.grauInstrucao" outlined></v-text-field>
        </v-col>
	</v-row>
		</v-container>
</template>
<script>
import { mapState } from 'vuex'
import metodos from '@/mixins/metodos'

	export default{
		props:['dados'],
		computed:{
			...mapState(['listaStatus', 'listaPerfis', 'listaClas']),
		},
		mixins: [metodos],
		data(){
			return{
			}
		},

	}
</script>
<style scoped>
	
	
</style>